export default class Finance {
    constructor(parent) {
        this.parent = parent;        
        this.hashManager = parent.hashManager;
        this.data = parent.data;
        this.car = parent.car;
        this.pricing = parent.pricing;
        this.client = parent.client;
        this.params = null;
        this.result = null;
    }

    async getFinanceParams() {
        const capCode = this.pricing.getCarCapCode();

        const price = this.pricing.getCarBasePrice({ financeableAdditionalProducts: true });
        const deliveryCharge = this.pricing.getCarBundlePrice({ type: 'deliveryFee' });
        const ved = this.pricing.getCarBundlePrice({ type: 'ved' });
        const firstRegistration = this.pricing.getCarBundlePrice({ type: 'firstRegistrationFee' });
        
        this.paramsRequest = this.client.getFinanceParams(capCode, price, deliveryCharge, ved, firstRegistration);
        return this.waitForFinanceParams();
    }

    async waitForFinanceParams() {
        return this.params = await this.paramsRequest;
    }

    async getFinance() {
        const productToken = this.currentParams?.token;
        const totalDeposit = Number(this.deposit) + Number(this.getFinanceContribution());
        this.financeRequest = this.client.getFinance(productToken, this.term, totalDeposit, this.mileage ?? 0);
        return this.waitForFinance();
    }

    async waitForFinance() {
        return this.result = await this.financeRequest;
    }

    getCurrentParams() {
        return this.currentParams = this.params?.products.find((p) => p.financeTypeCode === this.type);
    }

    fromUrl() {
        this.type = this.hashManager.get('payment');
        this.deposit = this.hashManager.get('deposit');
        this.term = this.hashManager.get('term');
        this.mileage = this.hashManager.get('mileage');
    }

    toUrl() {
        this.hashManager.set('payment', this.type);
        this.deposit ? this.hashManager.set('deposit', this.deposit) : this.hashManager.remove('deposit');
        this.mileage ? this.hashManager.set('mileage', this.mileage) : this.hashManager.remove('mileage');
        this.term ? this.hashManager.set('term', this.term) : this.hashManager.remove('term');
        this.hashManager.update();
    }

    update(finance) {
        this.type = finance.type;
        this.deposit = finance.deposit;
        this.term = finance.term;
        this.mileage = finance.mileage;
    }

    getFinanceContribution() {
        return Number(this.currentParams?.fda ?? 0);
    }

    getOTP() {
        return this.currentParams
            ?.productConstraints
            ?.vaps
            ?.categories?.find((c) => c?.category === 'OPTION_TO_PURCHASE_FEE')
            ?.vaps?.find((c) => c?.description?.startsWith('OTP#'))
            ?.description
            ?.split('#')?.[1];
    }

    getExcessMileage() {
        return this.currentParams
            ?.productConstraints
            ?.vaps
            ?.categories?.find((c) => c?.category === 'OTHER_NON_INSURANCE')
            ?.vaps?.find((c) => c?.description?.startsWith('EM#'))
            ?.description
            ?.split('#')?.[1];
    }
}
